import { TaskPriority } from '@business/constants/task';
import { CommentResponse } from '@business/entities/comment';
import { ProjectId, ProjectResponse } from '@business/entities/project';
import { ProjectSectionResponse } from '@business/entities/project/ProjectSectionResponse';
import { Endpoint } from '../endpoint';
import { SupportTaskResponse } from '@modules/support/SupportTaskResponse';
import { TicketId } from '@business/entities/SupportTicket';

/** Step **/
export function fetchTasks(id: TicketId) {
  return Endpoint.get<SupportTaskResponse[]>(`@gc/support-task/tasks/${id}`);
}

export function fetchTask(id: string) {
  return Endpoint.get<SupportTaskResponse>(`@gc/support-task/${id}`);
}

export function createTask(ticketId: TicketId, data: Partial<SupportTaskResponse>, parentStepId?: string) {
  data.parentId = parentStepId;
  return Endpoint.post<SupportTaskResponse[]>(`@gc/support-task/create`, { data: { ...data, ticketId } });
}

export function updateTask(id: string, data: Partial<SupportTaskResponse>) {
  return Endpoint.patch<SupportTaskResponse[]>(`@gc/support-task/task/${id}`, { data });
}

export function deleteTask(id: string) {
  return Endpoint.post<SupportTaskResponse[]>(`@gc/support-task/delete-task/${id}`);
}

export function duplicateTask(id: string) {
  return Endpoint.post<SupportTaskResponse[]>(`@gc/support-task/duplicate-task/${id}`);
}

export function setProjectStepPriority(stepId: string, priority: TaskPriority) {
  return Endpoint.post<SupportTaskResponse>(`@gc/support-task/set-project-step-priority/${stepId}`, { data: { priority } });
}

export function sortSteps(ids: string[]) {
  return Endpoint.post<SupportTaskResponse[]>(`@gc/support-task/sort-step`, { data: { ids } });
}

export function updateUsers(taskId: string, users: string[]) {
  return Endpoint.post<SupportTaskResponse>(`@gc/support-task/task-assign/${taskId}`, { data: { users } });
}

export function toggleTask(stepId: string, completeAll?: boolean) {
  return Endpoint.post<SupportTaskResponse[]>(`@gc/support-task/toggle/${stepId}`, { data: { completeAll: completeAll || false } });
}

export function createStepComment(id: string, data: Partial<CommentResponse>) {
  return Endpoint.post<ProjectSectionResponse[]>(`@gc/project/sections/step-comment/${id}`, { data });
}

export function assignProjectStep(stepId: string, data: string[]) {
  return Endpoint.post<ProjectSectionResponse[]>(`@gc/project/sections/assign-project-step/${stepId}`, { data: { data } });
}

export function orderTodos(projectId: ProjectId, items: any) {
  return Endpoint.post<ProjectResponse>(`@gc/organizations/project/order-todos/${projectId}`, { data: { items } });
}
